import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShoppingBag, Tag, Store, CalendarDays } from "lucide-react";
import client, { money } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

const Chips = ({ items, empty }) => (
  <div className="flex flex-wrap gap-1.5 mt-2">
    {items.length ? items.map((t) => <span key={t} className="rounded-full bg-pp-cream px-3 py-1 text-xs font-semibold text-pp-text">{t}</span>)
      : <span className="text-xs text-pp-muted">{empty}</span>}
  </div>
);

export default function ShoppingHabits() {
  const [p, setP] = useState(null);
  useEffect(() => { client.get("/personal/profile").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const toggle = async (v) => {
    try { await client.put("/personal/settings", { personalize: v }); setP({ ...p, personalize: v }); toast.success(v ? "Personalized picks turned on" : "Personalized picks turned off"); }
    catch { toast.error("Couldn't save"); }
  };
  const busiest = [...p.shopping_days].sort((a, b) => b.trips - a.trips)[0];
  return (
    <div className="bg-white rounded-3xl p-5 pp-shadow space-y-4" data-testid="shopping-habits">
      <div className="flex items-start justify-between gap-3">
        <div><h2 className="font-extrabold text-pp-text">Your shopping habits</h2>
          <p className="text-xs text-pp-muted">Used only to tailor your deals and picks. Never sold.</p></div>
        <label className="flex items-center gap-2 text-xs font-semibold text-pp-text shrink-0">Personalize
          <Switch checked={p.personalize} onCheckedChange={toggle} data-testid="personalize-toggle" /></label>
      </div>
      <div><p className="text-sm font-bold text-pp-text flex items-center gap-1.5"><ShoppingBag className="h-4 w-4 text-pp-forest" /> You buy most often</p>
        <Chips items={p.top_products.slice(0, 6).map((x) => x.name)} empty="Add items or shop a trip to see this." /></div>
      <div><p className="text-sm font-bold text-pp-text flex items-center gap-1.5"><Tag className="h-4 w-4 text-pp-gold" /> Favourite brands</p>
        <Chips items={p.top_brands.map((x) => x.name)} empty="No brand pattern yet." /></div>
      <div><p className="text-sm font-bold text-pp-text flex items-center gap-1.5"><Store className="h-4 w-4 text-pp-info" /> Stores you use</p>
        <Chips items={p.favourite_stores.map((x) => x.name)} empty="No trips yet." /></div>
      <div className="grid grid-cols-3 gap-2 text-center">
        <div className="rounded-2xl bg-pp-cream p-2.5"><p className="text-lg font-extrabold text-pp-forest">{p.deal_seeker_pct}%</p><p className="text-[11px] text-pp-muted">bought on deal</p></div>
        <div className="rounded-2xl bg-pp-cream p-2.5"><p className="text-lg font-extrabold text-pp-forest">{money(p.avg_basket)}</p><p className="text-[11px] text-pp-muted">avg basket</p></div>
        <div className="rounded-2xl bg-pp-cream p-2.5"><p className="text-lg font-extrabold text-pp-forest flex items-center justify-center gap-1"><CalendarDays className="h-4 w-4" />{busiest?.trips ? busiest.day : "—"}</p><p className="text-[11px] text-pp-muted">usual shop day</p></div>
      </div>
    </div>
  );
}
